import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { numberToCurrency } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-prepaid-balance-card',
	templateUrl: './prepaid-balance-card.component.html',
	styleUrls: ['./prepaid-balance-card.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrepaidBalanceCardComponent implements OnInit, OnDestroy {
	@Input() venue: Venue;
	@Input() title = '';
	@Input() subtitle = '';
	@Input() balance: number;
	@Input() showInput = false;
	@Input() leftToPay: number;

	@Output() onChange = new EventEmitter<number>();

	numberToCurrency = numberToCurrency

	balanceControl = new FormControl('');
	private valueChangesSub: Subscription;

	ngOnInit(): void {
		this.valueChangesSub = this.balanceControl.valueChanges.subscribe(value =>
			this.handleInputChange(String(value))
		);
	}

	ngOnDestroy(): void {
		this.valueChangesSub?.unsubscribe();
	}

	private handleInputChange(rawValue: string): void {
		console.log(rawValue);
		
		let value = rawValue;
		const maxValue = Math.min(this.balance, this.leftToPay);
		
		if (!rawValue) {
			value = '0';
		}

		if (rawValue.endsWith(',') || rawValue.endsWith('.')) {
			return
		}		

		if (rawValue.length > 4) {
			value = rawValue.slice(0, 4)
		}
		
		if (+value > maxValue) {
			value = String(maxValue);
		}
		
		if (+value <= 0) {
			value = '0';
		}

		console.log(value);
		

		this.balanceControl.setValue(parseFloat(value), {emitEvent: false});
		this.onChange.emit(parseFloat(value));
	}

	private preventWheel = (e: WheelEvent) => e.preventDefault();

	private preventArrowKeys = (e: KeyboardEvent) => {
		if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
			e.preventDefault();
		}
	};

	disableScrollOnWheel(event: any): void {
		const inputEl = event.target as HTMLElement;
		inputEl.addEventListener('wheel', this.preventWheel, {passive: false});
		inputEl.addEventListener('keydown', this.preventArrowKeys);
	}

	enableScrollOnWheel(event: any): void {
		const inputEl = event.target as HTMLElement;
		inputEl.removeEventListener('wheel', this.preventWheel);
		inputEl.removeEventListener('keydown', this.preventArrowKeys);
	}
}
